package top.wcpe.allincore.ui.runtime.theme

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.render.UiRenderBridge
import kotlin.jvm.JvmStatic
import kotlin.math.roundToInt

/**
 * 状态层（state layer）工具。
 *
 * 在 hover / focus / pressed 时，在元素表面叠加一层 onColor + 较低不透明度。
 * 提供两类无副作用纯函数：
 * - [withAlpha]：把 ARGB 的 alpha 通道乘以一个比例
 * - [overlay]：用 [UiRenderBridge.fillRect] 叠一层半透明矩形
 */
object StateLayer {

    /** ARGB 中 alpha 位的右移位数。 */
    private const val ALPHA_SHIFT = 24

    /** 单字节掩码。 */
    private const val BYTE_MASK = 0xFF

    /** RGB 三通道掩码（剔除 alpha）。 */
    private const val RGB_MASK = 0x00FFFFFF

    /**
     * 把 ARGB 的 alpha 通道乘以 [factor]（钳位到 0..1），返回新的 ARGB。RGB 通道保持不变。
     */
    @JvmStatic
    fun withAlpha(argb: Int, factor: Float): Int {
        val f = factor.coerceIn(0f, 1f)
        val srcA = (argb ushr ALPHA_SHIFT) and BYTE_MASK
        val a = (srcA * f).roundToInt().coerceIn(0, BYTE_MASK)
        return (a shl ALPHA_SHIFT) or (argb and RGB_MASK)
    }

    /** 在指定 box 上叠一层半透明颜色矩形。 */
    @JvmStatic
    fun overlay(bridge: UiRenderBridge, box: Box, color: Int, alpha: Float) {
        bridge.fillRect(box.x(), box.y(), box.width(), box.height(), withAlpha(color, alpha))
    }

    /** 在自定义矩形区域上叠一层半透明颜色。 */
    @JvmStatic
    fun overlay(bridge: UiRenderBridge, x: Float, y: Float, w: Float, h: Float, color: Int, alpha: Float) {
        bridge.fillRect(x, y, w, h, withAlpha(color, alpha))
    }
}
